module.exports = __webpack_public_path__ + "static/media/smile-plus.ba1ad3e8.svg";